import defaultConfig from '@/common/default-filter-config'


export default {
  data() {
    return {
      loading: true,
      isShowMore: false,
      separatorIndex: 0,
      districtOptions: null, // 筛选城市后，districtOptions 为该城市下的区域
      filterItems: [],
    }
  },
  mounted() {
    this.separatorIndex = this.items.indexOf('|')
  },
  methods: {
    renderFilterItems(res, perfix = 'RENTAL_FEATURE_') {
      let query = res.query.filter
      this.loading = false
      Object.keys(query).forEach(filterName => {
        this.filterItems.forEach((item, index) => {
          if (this.filterItems[index].key === filterName) {
            this.filterItems[index].options = query[filterName]
          }
        })
        if (filterName.startsWith(perfix)) {
          let name = filterName.replace(perfix, '').toLowerCase()
          let config = Object.assign(defaultConfig(), query.filterName)
          config.name = name
          config.options = query[filterName]
          this.filterItems.push(config)

        }
      })

      this.filterItems.forEach(item => {
        if (item.addon) {
          item.options = item.options && item.options.length ? item.addon.concat(item.options) : item.addon
        }
      })
    },
    formatTooltip(val) {
      return val === 100 ? this.$t('noLimitPrice') : '$ ' + val
    },
    onSelectChange({ name, selected }) {
      if (name === 'city') {
        this.onCityChange(selected)
      } else {
        this.onChange(name, selected)
      }
    },
    onChange(name, idList) {
      this.result[name] = idList
      // 清空或更换city时同时取消district选择
      if (name === 'city') {
        this.result.district = ['-1']
      }
      this.$emit('change', this.result)
    },
    onCityChange(cityIdList) {
      // 目前城市单选，cityIdList只存在一个
      const cityId = cityIdList[0]
      let cityFilterIndex = this.filterItems.findIndex(item => item.name === 'city')
      let districtFilterIndex = this.filterItems.findIndex(item => item.name === 'district')
      this.$refs['appSelect_city'][0].setSelect(cityId)
      this.$refs['appSelect_district'][0].setSelect(this.filterItems[cityFilterIndex].default)
      this.districtOptions = this.filterItems[districtFilterIndex].options.filter(dist => dist.related[0] === cityId)
      this.onChange('city', cityIdList)
    },
    onPriceChange() {
      this.onChange()
    },
    reset(max = 50000) {
      // 重置选项为默认
      this.filterItems.forEach(item => {
        let ref = this.$refs[`appSelect_${item.name}`]
        if (ref) {
          if (Array.isArray(ref)) {
            ref[0].setSelect(item.default)
          } else {
            ref.setSelect(item.default)
          }


        }

      })
      this.result = {}
      this.onChange()
      this.result.priceRange = [0, max]
    },
  }
}
